import { Button } from '@carbon/react';
import { ShoppingCart } from '@carbon/icons-react';
import { hasPermission, useAdmin, type RecordValues } from '@pos/admin-ui';
import { useTranslation } from '@pos/i18n';
import { useNavigate } from 'react-router';

/** A member account's orders (ADR 0044): the order list filtered to the account, for those who may read orders. */
export function MemberOrdersButton({ account }: { account: RecordValues }) {
  const { t } = useTranslation();
  const { session } = useAdmin();
  const navigate = useNavigate();
  if (!hasPermission(session, 'ho.orders.read')) return null;
  return (
    <Button kind="tertiary" renderIcon={ShoppingCart} onClick={() => void navigate(`/orders?memberId=${String(account.id)}`)}>
      {t('loyalty.viewOrders')}
    </Button>
  );
}
